import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const SeatingCapacity = (props) => {
  return (
    <FormGroup controlId="seatingCap">
      <Col componentClass={ControlLabel} sm={5}>
        Seating Capacity (excluding Driver) *
      </Col>
    <Col sm={7}>
        <FormControl
          type="number"
          value={props.seatingCap}
          onChange={props.handleChangeSeatingCap}
          onBlur={() => props.validation(true)}
          autoComplete="off"
          required />
    </Col>
    </FormGroup>
  )
}

SeatingCapacity.propTypes = {
  seatingCap: PropTypes.number,
  handleChangeSeatingCap: PropTypes.func,
  validation: PropTypes.func
};

export default SeatingCapacity;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/seatingCapacity/SeatingCapacity.js